import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	processedInvoiceQueries,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import CreateInvoiceCommentForm
	from "~/modules/billing/components/InvoiceDetailsView/components/CreateInvoiceCommentSidebar/CreateInvoiceCommentForm";

type Props = {
	invoiceId: string
	isOpen: boolean;
	onClose: () => void;
	projectId: string | null;
};

const CreateInvoiceCommentSidebar: React.FunctionComponent<Props> = ({
	invoiceId,
	isOpen,
	onClose,
	projectId,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceId).queryKey });
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		if (projectId) {
			queryClient.invalidateQueries({ queryKey: processedInvoiceQueries.byProject(projectId).queryKey });
		}
		onClose();
	}, [invoiceId, onClose, projectId, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && <CreateInvoiceCommentForm invoiceId={invoiceId}
												 onCancel={onClose}
												 onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default CreateInvoiceCommentSidebar;
